import { useLocation } from '@wirechunk/ui';
import type { FunctionComponent } from 'react';
import { useEffect } from 'react';

export const ScrollToTop: FunctionComponent = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
};
